import http from '@/libs/axios'

export function getStorageMaterial(query) {
  return http({
    url: '/product/materials/',
    method: 'GET',
    params: query,
  })
}

export function createStorageMaterial(data) {
  return http({
    url: '/product/materials/',
    method: 'POST',
    data,
  })
}

export function updateStorageMaterial(data) {
  return http({
    url: `/product/materials/${data.id}/`,
    method: 'PATCH',
    data,
  })
}

export function deleteStorageMaterial(id) {
  return http({
    url: `/product/materials/${id}/`,
    method: 'DELETE',
  })
}

export function getStorageInstrument(query) {
  return http({
    url: '/instruments/tools/',
    method: 'GET',
    params: query,
  })
}

export function createStorageInstrument(data) {
  return http({
    url: '/instruments/tools/',
    method: 'POST',
    data,
  })
}
